import * as React from 'react';
import {
  Card, CardContent, CardMedia,
  Grid, List, ListItem, ListItemIcon, ListItemText,
  Typography
} from "@mui/material";
import {Box, Stack} from "@mui/system";
import Oven from "../../images/rm-oven.jpeg";
import {WheatIcon} from "../icon/WheatIcon";

function Contact(props) {
  return (
    <Grid container padding={2} paddingLeft={{xs: '5%', sm: '10%', md: '15%', lg: '20%'}} paddingRight={{xs: '5%', sm: '10%', md: '15%', lg: '20%'}}
          justifyContent={'center'} alignItems={'center'}>
      <Stack spacing={2}>
        <Typography align={'center'} variant={'h5'}>Contact Info</Typography>
        <Card variant={'elevation'} elevation={5} width="80%">
          <CardContent sx={{marginTop: -1, marginBottom: -3}}>
            <List sx={{marginLeft: '5%'}}>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  <Box fontWeight={500}>Fulton neighborhood, SW Minneapolis, MN</Box>
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  <a href={"mailto:dan.minnehaha@gmail.com"}>dan.minnehaha@gmail.com</a>
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  <a href={'https://www.hotplate.com/minnehaha.bread'} target={'_blank'} rel="noreferrer">Hotplate Store</a>
                </ListItemText>
              </ListItem>
            </List>
          </CardContent>
          <CardMedia sx={{marginTop: 2}} component="img" image={Oven}/>
        </Card>
      </Stack>
    </Grid>
  )
}

export { Contact }